import axios from 'axios';
import Vue from 'vue'

const httpClient = axios.create({
  headers: {}
});

var username = null;
var profile_id = null;
var token = null;

// const getAuthToken = () => Vue.CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.VUE_APP_SECRET_QR_PASSWORD).toString(Vue.CryptoJS.enc.Utf8);
const authInterceptor = (config) => {
    // config.headers['authorization'] = "Token " + getAuthToken();
    if(localStorage.getItem('username') != null && localStorage.getItem('username') != 'null'){
      username = localStorage.getItem('username');
    }
    
    if(localStorage.getItem('profile_id') != null && localStorage.getItem('profile_id') != 'null'){
      profile_id = Vue.CryptoJS.AES.decrypt(localStorage.getItem('profile_id'), process.env.VUE_APP_SECRET_QR_PASSWORD).toString(Vue.CryptoJS.enc.Utf8);
    }

    if(localStorage.getItem('token') != null && localStorage.getItem('token') != 'null'){
      token = Vue.CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.VUE_APP_SECRET_QR_PASSWORD).toString(Vue.CryptoJS.enc.Utf8);
    }

    let rn = parseInt(localStorage.getItem('rn')) + 1;
    let qrData = {name: 'Zinger', username: username, profile_id: profile_id, rn: rn, token: token};
    let encData = Vue.CryptoJS.AES.encrypt(JSON.stringify(qrData), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();
    config.headers['Principal-Header'] = encData;

    if(localStorage.getItem('rn') != null && localStorage.getItem('rn') != 'null'){
      localStorage.setItem('rn', rn)
    }

    return config;
}

httpClient.interceptors.request.use(authInterceptor);

export default httpClient;